import { render, staticRenderFns } from "./ExerciseView.vue?vue&type=template&id=0c4e52f9&scoped=true&"
import script from "./ExerciseView.vue?vue&type=script&lang=js&"
export * from "./ExerciseView.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseView.vue?vue&type=style&index=0&id=0c4e52f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e52f9",
  null
  
)

export default component.exports